import React, { useState, useEffect } from 'react';
import { Button, Container } from '@mui/material';
import Select from "react-select";
import { Form, Col, Row } from 'react-bootstrap';
import { PuffLoader } from 'react-spinners';
import PieRechartComponent from './PieChart';
import { baseURL } from '../base_url';
import axios from 'axios';
import BarChart from "./BarChart";
import BarChart2 from "./BarChart2";
import BarChart3 from "./BarChart3";
import Swal from 'sweetalert2';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import axiosInstance from '../../utils/axiosConfig';
import VwBarChart  from "./vwBarChart";
import RidesIQBarChart from './ridesIQBarChart';

import "./Dashboard.css";

const Dashboard = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [selectedCompany, setSelectedCompany] = useState('')
    const [companyItems, setCompanyItems] = useState([])
    const [selectedLocation, setSelectedLocation] = useState('')
    const [locationItems, setLocationItems] = useState([])
    const [locDataItems, setLocDataItems] = useState([])
    const [teleUtilize, setTeleUtilize] = useState([])
    const [agreeUtilize, setAgreeUtilize] = useState([])
    const [fleetApiCount, setFleetApiCount] = useState([])
    const [fleetApiCount3, setFleetApiCount3] = useState([])
    const [fleetCount, setFleetCount] = useState([])

    const loggedInUser = sessionStorage.getItem("tm_token");
    const foundUser = JSON.parse(loggedInUser);
    const authToken = foundUser['auth_token'];

    const [vwFleetCount, setVWFleetCount] = useState([])
    const [ridesiqFleetCount, setRidesiqFleetCount] = useState([])
    const [locationWiseAgreement, setLocationWiseAgreement] = useState([])

    useEffect(() => {
        setLoading(true);
        axiosInstance.get(baseURL + "/get_company_setup?status=active&admin_id=" + foundUser['tm_id']).then((res) => {
            const allOption = { label: "All", value: "0" };
            const menuList = res.data.data.map((val1) => {
            return { label: val1.company_name, value: val1._id }
            })
            setCompanyItems([allOption, ...menuList])
        });
        setLoading(false);
    },[]);
    useEffect(() => {
        axiosInstance.get(baseURL + "/get_location_setup?status=active&admin_id=" + foundUser['tm_id']).then((res) => {
            const allOption = { label: "All", value: "0" };
            const menuList2 = res.data.data.map((val1) => {
                return { label: val1.location_name, value: val1._id }  
            })
            setLocationItems([allOption, ...menuList2])
        });
    },[]);
    useEffect(() => {
        axiosInstance.get(baseURL + "/get_fleet_make_count?status=active&loc_id=0&admin_id=" + foundUser['tm_id']).then((res) => {
            const allOption = { label: "All", value: "0" };
            const menuList2 = res.data.data.map((val1,i) => {
                return { label: val1['category'], value:val1['count'] }
            })
            setFleetApiCount(menuList2)
        });
    },[]);
    useEffect(() => {
        axiosInstance.get(baseURL + "/get_fleet_make_count3?status=active&loc_id=0&admin_id=" + foundUser['tm_id']).then((res) => {
            const allOption = { label: "All", value: "0" };
            const menuList2 = res.data.data.map((val1,i) => {
                return { label: val1['category'], value:val1['count'] }
            })
            setFleetApiCount3(menuList2)
        });
    },[]);
    useEffect(() => {
        setLoading(true);
        axiosInstance.get(baseURL + "/get_fleet_make_count2?status=active&loc_id=0&admin_id=" + foundUser['tm_id']).then((res) => {
            const allOption = { label: "All", value: "0" };
            const menuList2 = res.data.data.map((val1,i) => {
                return { label: val1['make'], value:val1['count'] }
            })
            setLoading(false);
            setFleetCount(menuList2)
        });
    },[]);
    useEffect(() => {
        setSelectedCompany(companyItems.find(option => option.value === '0'))
        setSelectedLocation(locationItems.find(option => option.value === '0'))
        homeTableData('0','0');
    },[companyItems]);

       useEffect(() => {
        setLoading(true);
        axiosInstance.get(baseURL + "/get_fleet_make_count_vw?status=active&loc_id=0&admin_id=" + foundUser['tm_id']).then((res) => {
            const allOption = { label: "All", value: "0" };
            const vwMenuList = res.data.data.map((val1,i) => {
                return { label: val1['category'], value:val1['count'] }
            })
            setLoading(false);
            setVWFleetCount(vwMenuList)
        });
    },[]);
    useEffect(() => {
        setLoading(true);
        axiosInstance.get(baseURL + "/get_fleet_make_count_ridesiq?status=active&loc_id=0&admin_id=" + foundUser['tm_id']).then((res) => {
            const allOption = { label: "All", value: "0" };
            const ridesIQMenuList = res.data.data.map((val1,i) => {
                return { label: val1['category'], value:val1['count'] }
            })
            setLoading(false);
            setRidesiqFleetCount(ridesIQMenuList)
        });
    },[]);

    const handleCompanyChange = (selectedOption) => {
        setSelectedCompany(companyItems.find(option => option.value === selectedOption.value))
        axios.get(baseURL + "/get_location_setup?status=active&com_id="+selectedOption.value+"&admin_id=" + foundUser['tm_id']).then((res) => {
          const allOption = { label: "All", value: "0" };
          const menuList2 = res.data.data.map((val1) => {
            return { label: val1.location_name, value: val1._id }
          })
          setLocationItems([allOption, ...menuList2])
          setSelectedLocation([allOption, ...menuList2].find(option => option.value === '0'))
        });
        homeTableData(selectedOption.value,'0');
        return false;
        // sessionStorage.setItem('selected_location', '0');
        // setSelectedLocation(locationItems.find(option => option.value === '0'))
        // const options3 = getCompanyOptions(selectedOption.value);
        // setCompanyOptions(options3);
        // sessionStorage.setItem('selected_company', selectedOption.value);
        // setValues(companyItems.find((option) => option.value === selectedOption.value))
        // setSelectCompany(false);
        // return false;
    };
    const handleLocationChange = (selectedOption) =>{
        setSelectedLocation(locationItems.find(option => option.value === selectedOption.value))
        homeTableData(selectedCompany.value,selectedOption.value);
        fleetApiCountData(selectedCompany.value,selectedOption.value)
        fleetCountData(selectedCompany.value,selectedOption.value)
        return false;
    }
    const homeTableData = (com_id,loc_id) => {
        // setLoading(true);
        axiosInstance.get(baseURL + "/get_fleet_dashboard?com_id="+com_id+"&loc_id="+loc_id+"&admin_id=" + foundUser['tm_id'])
        .then((res) => {
            if(res.data.status === '1' && res.data.data.loc_group.length > 0){
                const menuList = res.data.data.loc_group.map((val1) => {
                    return { name: val1.location_name, value: val1.count }
                })
                setLocDataItems(menuList)
            }else{
                setLocDataItems([])
            }
            if(res.data.status === '1' && res.data.data.tele_group.length > 0){
                const menuList2 = res.data.data.tele_group.map((val1) => {
                    return { name: val1.tele_name, value: val1.count }
                })
                setTeleUtilize(menuList2)
            }else{
                setTeleUtilize([])
            }
            if(res.data.status === '1' && res.data.data.agree_group.length > 0){
                const menuList3 = res.data.data.agree_group.map((val1) => {
                    return { name: val1.agree_name, value: val1.count }
                })
                setAgreeUtilize(menuList3)
            }else{
                setAgreeUtilize([])
            }
            if(res.data.status === '1' && res.data.data.loc_agree_group.length > 0){
            const menuList4 = res.data.data.loc_agree_group.map((val1) => {
                return {
                    name: val1.location_name,
                    inAgreement: val1.InAgreement,
                    offAgreement: val1.OffAgreement
                }
            })
            setLocationWiseAgreement(menuList4)
            } else {
            setLocationWiseAgreement([])
            }
        })
    }

    const fleetApiCountData = (com_id,loc_id) => {
        setLoading(true);
        axios.get(baseURL + "/get_fleet_make_count?com_id="+com_id+"&loc_id="+loc_id+"&admin_id=" + foundUser['tm_id']).then((res) => {
            if(res.data.status === '1' && res.data.data.length > 0){
                const menuList = res.data.data.map((val1) => {
                    // "index", i)
                    return { label: val1.make, value: val1.count }
                })
                setFleetApiCount(menuList)
                setLoading(false);
            }else{
                setFleetApiCount([])
                setLoading(false);
            }
        });
    }

    const fleetCountData = (com_id,loc_id) => {
        // setLoading(true);
        axios.get(baseURL + "/get_fleet_make_count2?com_id="+com_id+"&loc_id="+loc_id+"&admin_id=" + foundUser['tm_id']).then((res) => {
            if(res.data.status === '1' && res.data.data.length > 0){
                const menuList = res.data.data.map((val1) => {
                    // "index", i)
                    return { label: val1.make, value: val1.count }
                })
                setFleetCount(menuList)
            }else{
                setFleetCount([])
            }
            // setLoading(false);
        });
    }

    return(
        <div className='body_class'>
        {loading ? (
            <div className="loader-overlay">
                <div className="loader">
                <PuffLoader color="#00308F" loading={true} size={200} />
                </div>
            </div>
        ) : ("")}
            <div className='container-fluid'>
                <>
                <div className='p-1'>
                    <div className='row'>
                        <div className='col-12'>
                        <Form.Group as={Row} className="mt-2" controlId="formPlaintextCountry">
                            <Form.Label column sm="1">Company</Form.Label>
                            <Col sm="5">
                            <Select placeholder="Select Company" options={companyItems} onChange={handleCompanyChange} value={selectedCompany}/>
                            </Col>
                            <Form.Label column sm="1">Location</Form.Label>
                            <Col sm="5">
                            <Select isDisabled placeholder="Select Location" options={locationItems} onChange={handleLocationChange} value={selectedLocation}/>
                            </Col>
                        </Form.Group>
                        </div>
                    </div>
                </div>
                <div>
                    <div className='row mt-3'>
                        <div className="col-12 col-lg-12">
                            <BarChart fleetApiCount={fleetApiCount} />
                        </div>
                        <div className="col-12 col-lg-12">
                            <BarChart3 fleetApiCount={fleetApiCount3} />
                        </div>
                        <div className="col-12 col-lg-12">
                            <VwBarChart vwFleetCount={vwFleetCount} />
                        </div>
                        <div className="col-12 col-lg-12">
                            <RidesIQBarChart ridesiqFleetCount={ridesiqFleetCount} />
                        </div>
                        <div className="col-12 col-lg-12">
                            <BarChart2 fleetCount={fleetCount} />
                        </div>
                      
                    </div>
                    <div className='row mt-3'>
                        <div className='col-12 col-lg-6'>
                            <div style={{border:"1px solid lightgray",boxShadow:"0 0 5px rgba(0, 0, 0, 0.1), 0 0 5px rgba(0, 0, 0, 0.1), 0 0 5px rgba(0, 0, 0, 0.1), 0 0 5px rgba(0, 0, 0, 0.1)"}}>
                            <h6 className='p-1 position-absolute'>Location Fleet Summary</h6>
                            <PieRechartComponent data={locDataItems} breakdownData={locationWiseAgreement}/>
                            </div>
                        </div>
                        <div className='col-12 col-lg-6'>
                            <div style={{border:"1px solid lightgray",boxShadow:"0 0 5px rgba(0, 0, 0, 0.1), 0 0 5px rgba(0, 0, 0, 0.1), 0 0 5px rgba(0, 0, 0, 0.1), 0 0 5px rgba(0, 0, 0, 0.1)"}}>
                            <h6 className='p-1 position-absolute'>Agreement Status Summary</h6>
                            <PieRechartComponent data={agreeUtilize}/>
                            </div>
                        </div>
                       
                    </div>
                    <div className='row mt-3'>
                        {/* <div className='col-12 col-lg-6'>
                        <div style={{border:"1px solid lightgray",boxShadow:"0 0 5px rgba(0, 0, 0, 0.1), 0 0 5px rgba(0, 0, 0, 0.1), 0 0 5px rgba(0, 0, 0, 0.1), 0 0 5px rgba(0, 0, 0, 0.1)"}}>
                          <h6 className='p-1 position-absolute'>Telematic Utilization</h6>
                          <PieRechartComponent  data={teleUtilize}/>
                        </div>
                      </div> */}
                    </div>
                </div>
                </>
            </div>
        </div>
    )
}

export default Dashboard;